// extracted by mini-css-extract-plugin
export default {"createDnaRoot":"createDna_createDnaRoot__9k5OA"};